@use "src/sedestral/sass/icons/icons";

.componentOfferPricing {
  height: 100%;
  width: 100%;
  overflow: hidden;
  box-sizing: border-box;
  border-radius: 14px;
  background: linear-gradient(180deg, #dbe9fd 0, #fafafa 216px);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25);
  color: #000;

  // le défilement vit dans un enfant : la racine garde ses coins ronds, la barre de défilement y est rognée
  .scroll {
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
  }

  // la croix reste visible en défilant : collée en haut du conteneur, sans hauteur pour ne rien décaler
  .closeWrap {
    position: sticky;
    top: 0;
    z-index: 50;
    display: flex;
    justify-content: flex-end;
    height: 0;

    .close {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      margin: 14px 14px 0 0;
      border-radius: 50%;
      background: #fff;
      box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.06), 0 4px 12px rgba(0, 0, 0, 0.12);
      cursor: pointer;
      transition: background 0.15s, transform 0.15s;

      &:hover {
        background: #f0f0f0;
      }

      &:active {
        transform: scale(0.95);
      }

      .closeIcon {
        width: 14px;
        height: 14px;

        @include icons.ico("black-close");
      }
    }
  }

  @media screen and (max-width: 768px) {
    border-radius: 14px 14px 0 0;
  }

  .global {
    width: 100%;
    min-height: 460px;
    padding: 28px 0 0;
    box-sizing: border-box;
  }
}
